module.exports = __webpack_public_path__ + "static/media/assurance_retraite_capital_retraite.126b0758.png";